import { render, staticRenderFns } from "./commercialTenantItem.vue?vue&type=template&id=0ef61792&scoped=true&"
import script from "./commercialTenantItem.vue?vue&type=script&lang=ts&"
export * from "./commercialTenantItem.vue?vue&type=script&lang=ts&"
import style0 from "./commercialTenantItem.vue?vue&type=style&index=0&id=0ef61792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef61792",
  null
  
)

export default component.exports